import { useContext, useMemo } from "react";
import { Switch, Route, type RouteComponentProps } from "react-router-dom";

import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Header as GenericHeader,
  HeaderMenuButtonType,
  HeaderMenuLinkType,
  IconName,
  Icon,
  HeaderHomePageMiddleSection,
  HeaderHomePageRightSection,
} from "@hopper-b2b/ui";
import { Box, Typography } from "@material-ui/core";

import { UserContext } from "../../../../App";
import {
  PATH_FLIGHTS,
  PATH_HOTELS,
  PATH_CARS,
  PATH_TRIPS,
  PATH_HOME,
  UNPROTECTED_PATHS,
} from "../../../../utils/urlPaths";
import { FAQS_LINK } from "../../constants";
import { HeaderLogos } from "../MobileHeader";
import "./styles.scss";

interface IHeaderProps {
  openSupportChat?: () => void;
}

const DesktopHeader = ({ openSupportChat }: IHeaderProps) => {
  return (
    <GenericHeader
      className={"b2b uber-generic-header"}
      fullWidth
      left={
        <Switch>
          <Route
            path={[PATH_CARS, PATH_FLIGHTS, PATH_HOME, PATH_HOTELS, PATH_TRIPS]}
            render={() => (
              <a href={PATH_HOME}>
                <HeaderLogos />
              </a>
            )}
          />
          <Route path="*" />
        </Switch>
      }
      toolbarClassName="b2b"
      center={
        <Switch>
          {/* <Route
            path={[PATH_FLIGHTS, PATH_HOTELS, PATH_CARS, PATH_TRIPS]}
            render={(browserRouterProps: RouteComponentProps) => (
              <UberHeaderHomePageMiddleSection {...browserRouterProps} />
            )}
          /> */}
          <Route path="*" />
        </Switch>
      }
      right={
        <Switch>
          <Route
            path={[PATH_FLIGHTS, PATH_HOTELS, PATH_CARS, PATH_TRIPS]}
            render={(browserRouterProps: RouteComponentProps) => (
              <UberHeaderHomePageRightSection {...browserRouterProps} />
            )}
          />
          <Route path="*" />
        </Switch>
      }
    />
  );
};

const UberHeaderHomePageMiddleSection = (props: RouteComponentProps) => {
  const { history } = props;

  const buttons = [
    {
      type: HeaderMenuButtonType.Flights,
      selected: history.location.pathname === PATH_FLIGHTS,
      content: (
        <Box className="funnel-button-content">
          <Box className="icon-rounded-background">
            <Icon name={IconName.Calendar} />
          </Box>

          <Typography>Search Flights</Typography>
        </Box>
      ),
      onClick: () => history.push(PATH_FLIGHTS),
    },
    // {
    //   type: HeaderMenuButtonType.Hotels,
    //   selected: history.location.pathname === PATH_HOTELS,
    //   content: (
    //     <Box className="funnel-button-content">
    //       <Box className="icon-rounded-background">
    //         <Icon name={IconName.HotelFunnelIcon} />
    //       </Box>
    //       <Typography>Search Hotels</Typography>
    //     </Box>
    //   ),
    //   onClick: () => history.push(PATH_HOTELS),
    // },
    // {
    //   type: HeaderMenuButtonType.Cars,
    //   selected: history.location.pathname === PATH_CARS,
    //   content: (
    //     <Box className="funnel-button-content">
    //       <Box className="icon-rounded-background">
    //         <Icon name={IconName.CarFunnelIcon} />
    //       </Box>
    //       <Typography>Search Cars</Typography>
    //     </Box>
    //   ),
    //   onClick: () => history.push(PATH_CARS),
    // },
  ];
  return (
    <HeaderHomePageMiddleSection className="b2b" buttons={buttons} {...props} />
  );
};

interface IUberHeaderHomePageRightSectionProps extends RouteComponentProps {
  displayOnlyIcon?: boolean;
}

const UberHeaderHomePageRightSection = (
  props: IUberHeaderHomePageRightSectionProps
) => {
  const { t, brand } = useI18nContext();
  const { displayOnlyIcon, ...routerProps } = props;
  const { history } = routerProps;
  const { sessionInfo } = useContext(UserContext);

  const links = useMemo(
    () => [
      {
        type: HeaderMenuLinkType.Faq,
        selected: false,
        content: <Typography>{t("faq")}</Typography>,
        onClick: () => window.open(FAQS_LINK, "_blank"),
        dropdownContent: null,
        displayOnlyIcon: displayOnlyIcon,
      },
    ],
    [displayOnlyIcon, t]
  );

  const getLinks = () => {
    return UNPROTECTED_PATHS.includes(routerProps.location.pathname)
      ? links.slice(0, 2)
      : links;
  };

  return (
    <HeaderHomePageRightSection
      links={getLinks()}
      {...routerProps}
      className="b2b"
      supportedLanguages={brand.supportedLanguages}
    />
  );
};

export default DesktopHeader;
